import React, { useState, useEffect, useRef, memo } from 'react';
import './index.less';
import BeforeRecording from './beforeRecording';
import { ReactComponent as Arrows } from '../../assets/icons/arrows.svg';
import Recording from './Recording/index';
import RecordComplete from './recordcomplete';
import { message } from 'antd';
import CountDownMash from './components/countDownMask/index';
import { useTranslation } from 'react-i18next';
import sendGaEvent from '@/ga';
import TipsMark from './components/tipsMark/index';

import { Trans } from 'react-i18next';
import { sendRecorderStatus } from '../../api/apis';
import Cookies from 'js-cookie';
import ScreenBanner from '../../assets/images/screen-banner.png';
import ScreenPurchase from './components/screenPurchase';
import { useSelector } from 'react-redux';
import Utils from '../../utils';
import ConvertDownload from './components/convertDownload';
import { ReactComponent as Bingo } from '../../assets/icons/bingo_white.svg';
import { ReactComponent as CloseWhite } from '../../assets/icons/close-white.svg';
import api_domain_config from '@/constants/common';

var mediaRecorder;
var audioContext;
const ScreenRecorder = memo(() => {
  const { t } = useTranslation(['screenRecorder', 'common']);

  const [Microphone, setMicrophone] = useState(false); //是否获取麦克风
  const [sysAudio, setSysAudio] = useState(true); //是否获取系统音频
  const [isRecord, setIsRecord] = useState(false); //是否开始录制
  const [showToast, setShowToast] = useState(false); //按钮是否可选
  const [isShowTip, setShowTip] = useState(false); //是否展示引导提示
  const [isClock, setIsClock] = useState(false); //是否结束倒计时
  let startTime = 0;

  const [isPauseVideo, setIsPauseVideo] = useState(true); //是否录制的状态
  const [recordComplete, setRecordComplete] = useState(false); //是否录制完成
  const [blob, setBlobData] = useState(null); //存储视频录制产生的媒体数据
  const [cutBlob, setCutBlob] = useState(null);
  const videoRef = useRef(null); //控制录屏的ref
  const countDownRef = useRef(null); //倒计时的ref
  const screenPurchaseRef = useRef(null); //购买弹框的方法ref
  const convertDeskRef = useRef(null); //桌面端convert的ref
  const [videoTime, setVideoTime] = useState(0); //录屏时长
  const [showBanner, setShowBanner] = useState(false);
  ////////////////////////三秒倒计时的外部组件
  const [CountDownOpen, setCountDownOpen] = useState(false);
  const [isStop, setIsStop] = useState(false); //是否结束录制
  const reducerData = useSelector((state) => state.common);
  const openScreenPurchase = (num) => {
    screenPurchaseRef.current.setIsModalOpen(true);
    let label;
    switch (num) {
      case 1:
        label = '3TrialOver';
        window.sessionStorage.reason = '2';
        break;
      case 2:
        label = '10minLimitTip';
        window.sessionStorage.reason = '4';
        break;
      case 3:
        label = '10minLimitPrompt';
        window.sessionStorage.reason = '4';
        break;
      case 4:
        label = 'DownloadAsMP4';
        window.sessionStorage.reason = '8';
        break;
      case 5:
        label = 'DownloadFullTime';
        window.sessionStorage.reason = '5';
        break;
      default:
        break;
    }
    screenPurchaseRef.current.setLabel(label);
  };
  const openDeskConvert = (isDownload) => {
    convertDeskRef.current.setIsModalOpen(true);
    if (isDownload) {
      convertDeskRef.current.setDownload(true);
    }
  };
  const closeConvert = () => {
    convertDeskRef.current.setIsModalOpen(false);
    convertDeskRef.current.setDownload(false);
  };

  const complete = () => {
    console.log('倒计时结束', CountDownOpen);
    sendGaEvent({
      category: 'UploadSuccess',
      action: '06SR_UploadSuccess',
      label: 'Null',
    });
    if (!Utils.computedSubscribe(reducerData)) {
      setShowBanner(true);
    }
    setCountDownOpen(false);
    setIsStop(false);
    beginRecord();
    sendGaEvent({
      category: 'enter_sr_page',
      action: 'enter_recording_page',
    });
  };

  useEffect(() => {
    if (Utils.computedSubscribe(reducerData)) {
      if (showBanner) {
        setShowBanner(false);
      }
    }
  }, [reducerData, showBanner]);

  const disComplete = () => {
    sendRecorderStatus('ERROR').then((obj) => console.log('录制上报', obj));
    countDownRef.current.stopped();
    setIsRecord(false); //停止录制
    setRecordComplete(false); //
    setCountDownOpen(false);
    setIsStop(false);
  };
  ///////////////////////////
  const [tipsStatus, setTipsStatus] = useState(false);
  const tipsComplete = () => {
    console.log('完成');
  };
  let record = [];
  let tenMinRecord = [];
  useEffect(() => {
    if (Microphone) {
      if (!Cookies.get('isGetMicrophone')) {
        setShowTip(true);
        Cookies.set('isGetMicrophone', 'true');
      }
      setShowToast(true); //打开首次引导的提示框
      window.navigator.mediaDevices
        .getUserMedia({
          audio: { echoCancellation: true },
        })
        .then((mic) => {
          setShowTip(false); //关闭提示
          setShowToast(false); //关闭不可选状态
          mic.getTracks().forEach((track) => track.stop());
        })
        .catch((err) => {
          setShowTip(false); //关闭提示
          setMicrophone(false);
          setShowToast(false); //关闭不可选状态
          const comp = (
            <Trans i18nKey={'screenRecorder:NoAudioAndTryAgain'}>
              Text
              <u>
                <span
                  style={{ color: '#6B57FF' }}
                  target='_blank'
                  rel='noopener noreferrer'
                  onClick={() => window.scrollTo(0, 1200)}
                >
                  link
                </span>
              </u>
            </Trans>
          );
          message.error(comp, 3);
          sendGaEvent({
            category: 'record',
            action: 'operate_tip',
            label: 'NoAudioPermission',
          });
        }); //这里首先判断麦克风是否正常
    } else {
      setShowToast(false); //关闭提示
      console.log('无麦克风权限');
    }
  }, [Microphone]);

  const recordingNew = () => {
    setIsStop(false);
    setIsRecord(false);
    setShowBanner(false);
    setRecordComplete(false);
    sendGaEvent({
      category: 'record',
      action: 'click_new_recording',
    });
  };

  const mergeAudioStreams = (screenStream, micStream) => {
    //合成系统音频流和麦克风音频流
    audioContext = new AudioContext();
    const destination = audioContext.createMediaStreamDestination();
    let hasDesktop = false;
    let hasVoice = false;
    if (screenStream && screenStream.getAudioTracks().length > 0) {
      const source1 = audioContext.createMediaStreamSource(screenStream);
      const desktopGain = audioContext.createGain();
      desktopGain.gain.value = 1;
      source1.connect(desktopGain).connect(destination);
      hasDesktop = true;
    }

    if (micStream && micStream.getAudioTracks().length > 0) {
      const source2 = audioContext.createMediaStreamSource(micStream);
      const voiceGain = audioContext.createGain();
      voiceGain.gain.value = 10;
      source2.connect(voiceGain).connect(destination);
      hasVoice = true;
    }
    return hasDesktop || hasVoice ? destination.stream.getAudioTracks() : [];
  };

  useEffect(() => {
    sendGaEvent({
      category: 'EnterFuncPage',
      action: '06SR_EnterFuncPage',
      label: 'Null',
    });
  }, []);

  useEffect(() => {
    if (isRecord) {
      window.onbeforeunload = () => {
        return 'close';
      };
    } else {
      window.onbeforeunload = () => {};
    }
  }, [isRecord]);

  useEffect(() => {
    if (window.stream !== undefined) {
      window.stream.getVideoTracks()[0].addEventListener('ended', () => {
        setIsStop(true);
        stopRecord();
      });
    } else {
      stopRecord();
    }
  }, [window.stream]);
  const onStartRecord = () => {
    if (Utils.computedSubscribe(reducerData)) {
      recordMedia();
    } else {
      let screenTime = Cookies.get('screenTimes');
      if (screenTime && +screenTime >= 3) {
        openScreenPurchase(1);
        sendGaEvent({
          category: 'Upgrade',
          action: 'ScreenRecorder_SubscribePromptShow',
          label: `3TrialOver_${Utils.systemCheck()}`,
        });
      } else {
        recordMedia();
      }
    }
  };

  const recordMedia = () => {
    if (!showToast) {
      setIsRecord(true);
      let micGa = Microphone ? 'MicrophoneOn' : 'MicrophoneOff';
      let sysGa = sysAudio ? 'SystemSoundOn' : 'SystemSoundOff';
      sendGaEvent({
        category: 'record',
        action: 'click_start_record',
        label: `${micGa}_${sysGa}`,
      });
      initMedia();
    }
  };
  /**
   * 1.选音频，无麦克风
   * 2.选麦克风，不选音频
   * 3.两个都不选
   * 4.两个都选
   */
  const initMedia = async () => {
    //1
    if (Microphone && !sysAudio) {
      //这里初始化视频流，麦克风音频流
      setTipsStatus(true);
      let screenStream = await navigator.mediaDevices
        .getDisplayMedia({ video: true })
        .catch((err) => {
          setIsRecord(false);
          message.error(t('GrantPermission'), 3);
          sendGaEvent({
            category: 'record',
            action: 'operate_tip',
            label: 'NoScreenPermission',
          });
          setShowBanner(false);
          setTipsStatus(false);
          stopRecord();
        });
      let mic = await navigator.mediaDevices
        .getUserMedia({ audio: { echoCancellation: true } })
        .catch((err) => {
          setIsRecord(false);
          message.error(t('NoAudioAndTryAgain'), 3);
          sendGaEvent({
            category: 'record',
            action: 'operate_tip',
            label: 'NoAudioPermission',
          });
          setTipsStatus(false);
          stopRecord();
        });

      if (screenStream !== undefined) {
        screenStream.addTrack(mic.getTracks()[0]); //这里是把用户的音频流加到屏幕的视频流里面，后续放在数组里一起转换blob
        videoRef.current.srcObject = screenStream;
        videoRef.current.muted = true;
        videoRef.current.volume = 0;
        window.stream = screenStream; //缓存屏幕流
        window.mic = mic; //缓存音频流
        setTipsStatus(false);
        setCountDownOpen(true);
        sendGaEvent({
          category: 'UploadStart',
          action: '06SR_UploadStart',
          label: 'Null',
        });
        sendGaEvent({
          category: 'record',
          action: 'start_countdown',
        });
      }
      ////////////////////////////////////////////////////////////
    } else if (!Microphone && sysAudio) {
      //选择音频,无麦克风2
      setTipsStatus(true);
      let screenStream = await navigator.mediaDevices
        .getDisplayMedia({ video: true, audio: { echoCancellation: true } })
        .catch((err) => {
          setIsRecord(false);
          message.error(t('GrantPermission'), 3);
          sendGaEvent({
            category: 'record',
            action: 'operate_tip',
            label: 'NoScreenPermission',
          });
          setShowBanner(false);
          setTipsStatus(false);
          stopRecord();
        });
      if (screenStream !== undefined) {
        setTipsStatus(false);
        videoRef.current.srcObject = screenStream;
        videoRef.current.muted = true;
        videoRef.current.volume = 0;
        window.stream = screenStream;
        setCountDownOpen(true);
        sendGaEvent({
          category: 'UploadStart',
          action: '06SR_UploadStart',
          label: 'Null',
        });
        sendGaEvent({
          category: 'record',
          action: 'start_countdown',
        });
      }
      ////////////////////////////////////////////////////////////////
    } else if (!Microphone && !sysAudio) {
      //都不选3
      setTipsStatus(true);
      let screenStream = await navigator.mediaDevices
        .getDisplayMedia({ video: true })
        .catch((err) => {
          setIsRecord(false);
          message.error(t('GrantPermission'), 3);
          sendGaEvent({
            category: 'record',
            action: 'operate_tip',
            label: 'NoScreenPermission',
          });
          setShowBanner(false);
          setTipsStatus(false);
          stopRecord();
        });
      if (screenStream !== undefined) {
        setTipsStatus(false);
        window.stream = screenStream;
        videoRef.current.srcObject = screenStream;
        videoRef.current.muted = true;
        videoRef.current.volume = 0;
        setCountDownOpen(true);
        sendGaEvent({
          category: 'UploadStart',
          action: '06SR_UploadStart',
          label: 'Null',
        });
        sendGaEvent({
          category: 'record',
          action: 'start_countdown',
        });
      }
      ///////////////////////////////////////////////////////////////////////
    } else if (Microphone && sysAudio) {
      //都选4
      setTipsStatus(true);
      let screenStream = await navigator.mediaDevices
        .getDisplayMedia({ video: true, audio: { echoCancellation: true } })
        .catch((err) => {
          setIsRecord(false);
          message.error(t('GrantPermission'), 3);
          sendGaEvent({
            category: 'record',
            action: 'operate_tip',
            label: 'NoScreenPermission',
          });
          setShowBanner(false);
          setTipsStatus(false);
          stopRecord();
        });
      window.screenStream = screenStream; //缓存旧的屏幕流
      let mic = await navigator.mediaDevices
        .getUserMedia({ video: false, audio: { echoCancellation: true } })
        .catch((err) => {
          setIsRecord(false);
          stopRecord();
          setTipsStatus(false);
        });
      window.mic = mic; //缓存旧的麦克风流
      if (screenStream !== undefined && mic !== undefined) {
        setTipsStatus(false);
        const tracks = [
          ...screenStream.getVideoTracks(),
          ...mergeAudioStreams(screenStream, mic),
        ];
        let stream = new MediaStream(tracks);

        //console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxx",stream)
        videoRef.current.srcObject = stream;
        videoRef.current.muted = true;
        videoRef.current.volume = 0;
        window.stream = stream;
        setCountDownOpen(true);
        sendGaEvent({
          category: 'UploadStart',
          action: '06SR_UploadStart',
          label: 'Null',
        });
        sendGaEvent({
          category: 'record',
          action: 'start_countdown',
        });
      }
    }
  };
  const getSupportedMimeTypes = () => {
    const possibleTypes = [
      'video/webm;codecs=h264,opus',
      'video/mp4;codecs=h264,aac',
      'video/webm;codecs=vp9,opus',
      'video/webm;codecs=vp8,opus',
    ];
    return possibleTypes.filter((mimeType) => {
      return MediaRecorder.isTypeSupported(mimeType);
    });
  };

  const beginRecord = () => {
    const options = { mimeType: getSupportedMimeTypes()[0] };
    mediaRecorder = new MediaRecorder(window.stream, options);
    mediaRecorder.onstop = (event) => {
      let screenTime = Cookies.get('screenTimes');
      if (screenTime) {
        Cookies.set('screenTimes', +screenTime + 1, {
          expires: 1,
          domain: api_domain_config.DOMAIN,
        });
      } else {
        Cookies.set('screenTimes', 1, {
          expires: 1,
          domain: api_domain_config.DOMAIN,
        });
      }
      console.log('录制停止了' + event);

      sendRecorderStatus('COMPLETED').then((obj) =>
        console.log('录制上报', obj)
      );
      const cutBlob = new Blob(tenMinRecord, {
        type: getSupportedMimeTypes()[0],
      });
      const blob = new Blob(record, { type: getSupportedMimeTypes()[0] });

      console.log(cutBlob, blob);
      if (blob.size > 0 && cutBlob.size > 0) {
        setCutBlob(cutBlob);
        setBlobData(blob);

        setRecordComplete(true);
        stopRecord();
      } else {
        recordingNew();
        stopRecord();
      }
    };
    mediaRecorder.ondataavailable = (event) => {
      console.log('handleDataAvailable', event);
      let duration = Math.floor(Date.now() - startTime);
      console.log(Date.now(), startTime, Date.now() - startTime);
      console.log(duration / 1000);
      if (event.data && event.data.size > 0) {
        if (tenMinRecord.length === 0) {
          tenMinRecord.push(event.data);
        }
        record.push(event.data);
      }
    };
    mediaRecorder.addEventListener('error', (err) => {
      console.log('error', err);
    });
    mediaRecorder.start(600000);
    startTime = Date.now();

    setIsClock(true);
    console.log('录制开始', startTime);
    setIsPauseVideo(true);
  };

  const controlRecord = () => {
    if (mediaRecorder !== undefined) {
      if (mediaRecorder.state === 'recording') {
        console.log('暂停');
        mediaRecorder.pause();
        videoRef.current.pause();
        setIsPauseVideo(false);
        setIsClock(false);
        sendGaEvent({
          category: 'record',
          action: 'pause_record',
        });
      } else if (mediaRecorder.state === 'paused') {
        console.log('继续');
        mediaRecorder.resume();
        videoRef.current.play();
        setIsPauseVideo(true);
        setIsClock(true);
        sendGaEvent({
          category: 'record',
          action: 'continue_record',
        });
      } else {
        console.log('闲置');
      }
    } else {
      console.log('未初始化');
    }
  };

  const stopRecord = () => {
    if (audioContext) {
      audioContext.close();
    }
    audioContext = undefined;
    if (window.screenStream) {
      window.screenStream.getTracks().forEach(function (track) {
        track.stop();
      });
    }
    if (window.mic) {
      let micTracks = window.mic.getTracks();
      for (let i = 0; i < window.mic.getTracks().length; i++) {
        micTracks[i].stop();
      }
    }
    //停止录制，停止媒体流
    if (mediaRecorder !== undefined && mediaRecorder !== null) {
      if (mediaRecorder && mediaRecorder.state === 'recording') {
        mediaRecorder.stop();
      }

      let tracks = window.stream.getTracks();
      for (let i = 0; i < tracks.length; i++) {
        tracks[i].stop();
      }
    }
    mediaRecorder = undefined;
    setIsClock(false);
    window.stream = undefined;
  };
  /**
     * 支持录屏的格式
      'video/webm;codecs=vp9,opus',
      'video/webm;codecs=vp8,opus',
      'video/webm;codecs=h264,opus',
     */
  return (
    <>
      <div className='record-bg'>
        {isShowTip ? (
          <div className='toast'>
            <Arrows className='arrows' />
            <div className='toastText'>{t('AccessMicrophone')}</div>
          </div>
        ) : (
          ''
        )}
        <TipsMark
          openstatus={tipsStatus}
          complete={tipsComplete}
          sysAudio={sysAudio}
        />
        <CountDownMash
          isStop={isStop}
          disComplete={disComplete}
          ref={countDownRef}
          openstatus={CountDownOpen}
          complete={complete}
        />
        {!isRecord ? (
          <BeforeRecording
            showToast={showToast}
            setMicrophone={setMicrophone}
            setSysAudio={setSysAudio}
            Microphone={Microphone}
            sysAudio={sysAudio}
            onStartRecord={onStartRecord}
          />
        ) : !recordComplete ? (
          <Recording
            ref={videoRef}
            isPauseVideo={isPauseVideo}
            controlRecord={controlRecord}
            sysAudio={sysAudio}
            Microphone={Microphone}
            stopRecord={stopRecord}
            isClock={isClock}
            setIsStop={setIsStop}
            setVideoTime={setVideoTime}
            showBanner={showBanner}
            openScreenPurchase={openScreenPurchase}
          />
        ) : (
          <RecordComplete
            blob={blob}
            cutBlob={cutBlob}
            recordingNew={recordingNew}
            videoTime={videoTime}
            openScreenPurchase={openScreenPurchase}
            openDeskConvert={openDeskConvert}
            closeConvert={closeConvert}
          />
        )}
        {showBanner ? (
          <div className='bottomAdvertise'>
            <div className='bannerPic'>
              <img src={ScreenBanner} alt='' />
            </div>
            <div className='featureText'>
              <div>{t('ScreenProFeature')}</div>
              <div className='features'>
                <div className='featureList'>
                  <Bingo className='bingo' /> {t('NoRecordLimit')}
                </div>
                <div className='featureList'>
                  <Bingo className='bingo' />
                  {t('DownloadMp4')}
                </div>
              </div>
            </div>
            <div className='textContainer'>
              <div className='leftText'>
                <Trans i18nKey={'screenRecorder:FreeScreenAccount'}>
                  Text
                  <span
                    className='highLight'
                    style={{ color: '#ffc628' }}
                    target='_blank'
                    rel='noopener noreferrer'
                  ></span>
                </Trans>
              </div>
              <div className='rightText'>
                <span className='highLight'>
                  {Utils.formatSeconds(videoTime)}
                </span>{' '}
                / 10:00
              </div>
            </div>
            <div
              onClick={() => {
                openScreenPurchase(3);
                sendGaEvent({
                  category: 'Upgrade',
                  action: 'ScreenRecorder_SubscribePromptShow',
                  label: `10minLimitPrompt_${Utils.systemCheck()}`,
                });
              }}
              className='upgrade'
            >
              {t('UpgradeNow')}
            </div>
            <CloseWhite
              onClick={() => setShowBanner(false)}
              className='closeIcon'
            />
          </div>
        ) : (
          ''
        )}
      </div>
      <ScreenPurchase ref={screenPurchaseRef} />
      <ConvertDownload ref={convertDeskRef} />
    </>
  );
});

export default ScreenRecorder;
